// Uclean-Admin-Dashboard/src/mocks/promo/_shared/errors.js
// Canonical engine error body shape from docs/admin-handover.md §8.

import { HttpResponse } from 'msw';

export function engineError(code, { status, message, ...extra } = {}) {
  return HttpResponse.json({ ...extra, code, message }, { status });
}

export function validationError(errors) {
  // 422 {errors: {field: [msg]}}
  return HttpResponse.json({ errors }, { status: 422 });
}
